import { useLazyQuery, useMutation } from '@apollo/client'
import React, { useEffect, useState, useRef } from 'react'
import { Spinner } from 'react-bootstrap'
import { AGENT_VERIFICATION, GET_AGENT_VERIFICATION_LIST } from '../../../../utils/GraphQLAPI'
import { KTCard, KTCardBody } from '../../../../_metronic/helpers'
import approveIcon from '../../../../_metronic/images/approve.svg'
import { UsersListPagination } from '../../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import SearchComponent from '../SearchComponent'
import Dropdown from 'react-bootstrap/Dropdown'
import moment from 'moment'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useFormik } from 'formik'
import DownloadCsv from '../../Download/DownloadCsv'
import './av.css'

const MySwal = withReactContent(Swal)

const AgentVerificationList = () => {
  const [pageNo, updatePageNo] = useState(0)
  const [total, setTotal] = useState<number>()
  const [agentVerification, setAgentVerification] = useState<any>()
  const [isCheckAll, setIsCheckAll] = useState<any>(false)
  const [isCheck, setIsCheck] = useState<any>([])
  const [btnValue, setBtnValue] = useState<any>('')
  const [renderTable, setRenderTable] = useState<boolean>(true)
  const [downloadData, setDownloadData] = useState<any>([])
  const [filterTempOptions, setFilterTempOptions] = useState<any>()
  const [csv, setCsv] = useState<boolean>(false)
  const csvRef = useRef<any>(null)

  const [filterOptions, setFilterOptions] = useState<any>({
    searchText: '',
    page: 1,
    perPage: 10,
  })

  // List API
  const [getAgentVerificationList, { loading, refetch }] = useLazyQuery(GET_AGENT_VERIFICATION_LIST, {
    fetchPolicy: 'network-only',
    variables: {
      agentVerificationListInput: filterOptions,
    },
    onCompleted: (data) => {
      setAgentVerification(data.getAgentVerificationList.agentVerificationList)
      setTotal(data.getAgentVerificationList.totalCount)
    },
    onError: (err) => console.log('error', err),
  })

  useEffect(() => {
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, page: pageNo + 1 }
    })
  }, [pageNo])

  const updateRowsPerPage = (value: any) => {
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, perPage: value, page: pageNo + 1 }
    })
  }

  const handleSearch = (searchValue: any) => {
    updatePageNo(0)
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, searchText: searchValue, page: pageNo + 1 }
    })
  }

  useEffect(() => {
    getAgentVerificationList()
  }, [filterOptions])

  // AV List Download API Hit
  const [getAgentVerificationCSVList, { loading: reload }] = useLazyQuery(
    GET_AGENT_VERIFICATION_LIST,
    {
      fetchPolicy: 'network-only',
      variables: {
        agentVerificationListInput: filterTempOptions,
      },
      onCompleted: (data) => {
        setDownloadData(data.getAgentVerificationList.agentVerificationList)
      },
      onError: (err) => console.log('error', err),
    }
  )

  // Checkbox
  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll)
    setIsCheck(agentVerification.map((d: any) => d.id))
    if (isCheckAll) {
      setIsCheck([])
    }
  }

  const handleClick = (e: any) => {
    const { id, checked } = e.target
    setIsCheck([...isCheck, id])
    if (!checked) {
      setIsCheck(isCheck.filter((item: any) => item !== id))
    }
  }

  // Bulk Approve/Reject
  const handleBulkBtnClick = (status: any) => {
    setBtnValue(status)
  }

  // Single Approve/Reject
  const handleBtnClick = (status: any, id: any) => {
    setBtnValue(status)
    setIsCheck([id])
  }

  // approve/reject form submit
  const formik = useFormik({
    initialValues: isCheck,
    enableReinitialize: true,
    onSubmit: async (values) => {
      agentVerificationList({
        variables: {
          agentVerificationInput: {
            agentVerificationIds: isCheck,
            status: btnValue,
          },
        },
      })
    },
  })

  const [agentVerificationList, { loading: reloadList }] = useMutation(AGENT_VERIFICATION, {
    onCompleted: (data) => {
      setRenderTable(false)

      if (data) {
        if (data.agentVerification[0].message === 'Updated Successfully') {
          const title =
            isCheck.length > 1
              ? `Agents are ${btnValue.toLowerCase()} successfully`
              : `Agent is ${btnValue.toLowerCase()} successfully`
          const options: any = {
            customClass: {
              popup: 'swal2-border-radius',
            },
            title,
            icon: 'success',
            confirmButtonColor: '#3E97FF',
          }
          setTimeout(() => {
            setRenderTable(true)
            MySwal.fire(options)
          }, 300)
        } else {
          const title1 = data.agentVerification.map((res: any) => {
            return `<p>${res.emailId} is already ${res.status}</p>`
          })
          const options: any = {
            customClass: {
              popup: 'swal2-border-radius',
            },
            html: title1.toString(),
            icon: 'success',
            confirmButtonColor: '#3E97FF',
          }
          setTimeout(() => {
            setRenderTable(true)
            MySwal.fire(options)
          }, 300)
        }
      } else {
        MySwal.fire({
          icon: 'error',
          title: 'Error in Agent Status Update',
        })
      }
      refetch()
      setBtnValue('')
      setIsCheck([])
      setIsCheckAll(false)
    },
    onError: (e: any) => {
      MySwal.fire({
        icon: 'error',
        title: e.message,
      })
    },
  })

  const csvHeaders = [
    { label: 'Name', key: 'agentName' },
    { label: 'Email ID', key: 'emailId' },
    { label: 'Sales Channel', key: 'salesChannelName' },
    { label: 'Created Date', key: 'createdAt' },
    { label: 'User Id', key: 'loginUsername' }
  ]

  useEffect(() => {
    const { page, perPage, ...rest } = filterOptions
    setFilterTempOptions(rest)
    setCsv(false)
  }, [])

  const csvDownloadFun = async () => {
    await getAgentVerificationCSVList()
    if (csvRef.current) {
      csvRef.current.link.click()
    }
  }

  console.log(downloadData, ">>>>>>downloadData")
  return (
    <KTCard>
      <div className='card card-custom'>
        <div className=' card-header card-body pb-0 border-0'>
          <div className='card-title'>
            <div className='d-flex align-items-center position-relative my-1'>
              <SearchComponent handleSearch={handleSearch} placeholder='Search agent' />
            </div>
          </div>

          {isCheck && isCheck.length === 0 && total !== 0 && (
            <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
              <div className='m-0'>
                <DownloadCsv
                  csvDownloadFun={csvDownloadFun}
                  reload={reload}
                  csvHeaders={csvHeaders}
                  csvRef={csvRef}
                  downloadData={downloadData}
                  downloadFileName='AgentVerification.csv'
                />
              </div>
            </div>
          )}

          {isCheck && isCheck.length > 0 ? (
            <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
              <form className='' onSubmit={formik.handleSubmit}>
                <div className='m-0'>
                  <h6 style={{ display: 'contents' }} className='fs-6'>
                    {isCheck.length} Selected
                  </h6>
                  <button
                    className='btn btn-light-primary fw-bold fs-base  fs-6 ms-4'
                    onClick={() => handleBulkBtnClick('REJECTED')}
                  >
                    <span className='svg-icon svg-icon-5'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='currentColor'
                        className='bi bi-x-square'
                        viewBox='0 0 16 16'
                      >
                        <path
                          d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 
                        2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z'
                        />
                        <path
                          d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0
                        0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z'
                        />
                      </svg>
                    </span>
                    Reject
                  </button>
                  <button
                    className='btn btn-primary fs-6 ms-3'
                    onClick={() => handleBulkBtnClick('APPROVED')}
                  >
                    <img src={approveIcon} alt='' className='svg-icon svg-icon-1' />
                    Approve
                  </button>
                </div>
              </form>
            </div>
          ) : (
            ''
          )}
        </div>
        <form className='' onSubmit={formik.handleSubmit}>
          <KTCardBody className='px-9 py-0 min-h-400px' scroll>
            {total !== 0 ? (
              <div className='table-responsive-md mt-4'>
                {loading || reloadList ? (
                  <div className='text-center'>
                    <Spinner animation='border' className='text-gray-600 text-center' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  renderTable && (
                    <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                          <th className='w-25px'>
                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                              <input
                                className='datatable-cell-center datatable-cell datatable-cell-check form-check-input bg-light-primary'
                                type='checkbox'
                                name='selectAll'
                                id='selectAll'
                                onClick={() => handleSelectAll()}
                                checked={isCheckAll}
                              />
                            </label>
                          </th>
                          <th className='header-title'>Name</th>
                          <th className='header-title'>Email ID</th>
                          <th className='header-title'>User Name</th>
                          <th className='header-title'>Sales Channel</th>
                          <th className='header-title'>Created Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {agentVerification &&
                          agentVerification.map((item: any) => {
                            return (
                              <tr className='border-bottom-2' key={item.id}>
                                <td>
                                  <label className='form-check form-check-sm form-check-custom form-check-solid me-5 '>
                                    <input
                                      className='form-check-input bg-light-primary'
                                      type='checkbox'
                                      key={item.id}
                                      name={item.agentName}
                                      id={item.id}
                                      onClick={handleClick}
                                      checked={isCheck.includes(item.id)}
                                    />
                                  </label>
                                </td>
                                <td className='content'>{item.agentName}</td>
                                <td className='content'>{!item.loginUsername ? item.emailId : "-"}</td>
                                <td className='content'>{item.loginUsername ? item.loginUsername : "-"}</td>
                                <td className='content'>{item.salesChannelName}</td>
                                <td className='content'>
                                  {moment.utc(item.createdAt).local().format('ll, hh:mm A')}
                                </td>
                                <td className='text-gray-600 fs-6 ps-0 fw-semibold'>
                                  <Dropdown className='show-override'>
                                    <Dropdown.Toggle
                                      id='dropdown-custom-1'
                                      className='text-gray-600 btn btn-sm btn-icon btn-active-light-primary btn-light-primary btn-arrow-overide'
                                      style={{ background: 'none!important' }}
                                    >
                                      <i className='bi bi-three-dots-vertical fs-7 text-primary'></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='py-2 menu-state-bg-primary'>
                                      <Dropdown.ItemText
                                        as='div'
                                        className='text-gray-600 fs-7 menu-item bg-hover-primary text-hover-white'
                                      >
                                        <button
                                          className='menu-link text-hover-white'
                                          style={{ border: 'none', background: 'none' }}
                                          onClick={() => handleBtnClick('APPROVED', item.id)}
                                        >
                                          Approve
                                        </button>
                                      </Dropdown.ItemText>
                                      <Dropdown.ItemText
                                        as='div'
                                        className='text-gray-600 fs-7 menu-item bg-hover-primary text-hover-white'
                                      >
                                        <button
                                          className='menu-link text-hover-white'
                                          style={{ border: 'none', background: 'none' }}
                                          onClick={() => handleBtnClick('REJECTED', item.id)}
                                        >
                                          Reject
                                        </button>
                                      </Dropdown.ItemText>
                                      <Dropdown.ItemText
                                        as='div'
                                        className='text-gray-600 fs-7 menu-item bg-hover-primary text-hover-white'
                                      >
                                        <button
                                          className='menu-link text-danger text-hover-white'
                                          style={{ border: 'none', background: 'none' }}
                                          onClick={() => handleBtnClick('DELETED', item.id)}
                                        >
                                          Delete
                                        </button>
                                      </Dropdown.ItemText>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                    </table>
                  )
                )}
              </div>
            ) : (
              <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
                No Results Found
              </div>
            )}
          </KTCardBody>
        </form>

        {total !== 0 ? (
          <div className='card-footer border-0'>
            <UsersListPagination
              page={pageNo}
              total={total}
              updatePage={updatePageNo}
              recordsPerPage={(e: any) => {
                updateRowsPerPage(parseInt(e))
              }}
              rowsPerPage={filterOptions.perPage}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </KTCard>
  )
}

export default AgentVerificationList
